import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Table,
  Tooltip,
} from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import ShowTotal from "../../components/ShowTotal";
import apiPath from "../../constants/apiPath";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";

function Index() {
  const sectionName = "Notification";
  const routeName = "notification";

  const api = {
    add: apiPath.addNotification,
    list: apiPath.listNotification,
    customerList: apiPath.customerList,
    serviceProviderList: apiPath.serviceProviderList,
  };

  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const navigate = useNavigate();

  const view = (id) => {
    navigate(`/${routeName}/view/${id}`);
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (_, { title }) => {
        return title ? title : "-";
      },
    },
    {
      title: "Notification For",
      dataIndex: "notification_for",
      key: "notification_for",
      render: (_, { notification_for }) => {
        return notification_for ? notification_for : "-";
      },
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
      render: (_, { message }) => {
        return message ? message : "-";
      },
    },
    {
      title: "Created On",
      key: "createdAt",
      dataIndex: "createdAt",
      render: (_, { createdAt }) => {
        return moment(createdAt).format("DD-MMM-YYYY");
      },
    },
    {
      title: "Action",
       
      render: (_, record) => {
        return (
          <Tooltip
            title={"View " + sectionName}
            color={"purple"}
            key={"view" + routeName}
          >
            <Button title="View" onClick={(e) => view(record._id)}>
              <i className="fa fa-light fa-eye"></i>
            </Button>
          </Tooltip>
        );
      },
    },
  ];

  const fetchData = (pagination, filters) => {
    setLoading(true);
    const filterActive = filters ? filters.is_active : null;
    request({
      url:
        api.list +
        `?status=${filterActive ? filterActive.join(",") : ""}&page=${
          pagination ? pagination.current : 1
        }&limit=${pagination ? pagination.pageSize : 10}`,
      method: "GET",

      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.list.docs);
        setPagination((prev) => ({
          current: pagination.current,
          total: data.data.list.totalDocs,
        }));
      },

      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChange = (pagination, filters) => {
    fetchData(pagination, filters);
  };

  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
  }, [refresh]);

  return (
    <>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={sectionName + " Management"}
              extra={
                <Button onClick={(e) => setVisible(true)}>
                  Send New {sectionName}
                </Button>
              }
            >
              <div className="total-record-cls">
                <h4 className="text-right">
                  {pagination.total
                    ? ShowTotal(pagination.total)
                    : ShowTotal(0)}
                </h4>
              </div>
              <div className="table-responsive customPagination">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    current: pagination.current,
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ["10", "20", "30", "50"],
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      {visible && (
        <SendNotiFrom
          show={visible}
          api={api}
          data={list}
          hide={() => setVisible(false)}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
    </>
  );
}

const SendNotiFrom = ({ show, api, hide, refresh }) => {
  const [form] = Form.useForm();
  const [selectType, setSelectType] = useState("All");
  const [userList, setUserList] = useState([]);
  const [selectUser, setSelectUser] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);

  const handleSelectAll = (e) => {
    const allUserIds = userList.map((user) => user._id);
    setSelectUser(e.target.checked ? allUserIds : []);
    setSelectAll(e.target.checked);
    setShowError(false);
  };
  const handleSubmit = () => {
    if (!selectAll) {
      setShowError(true);
      return;
    }
  };

  const handleTypeChange = (value) => {
    setSelectType(value);
    getList(value);
    setSelectUser([]);
    setLoading(false);
    form.resetFields(["user"]);
  };

  const handleUserChange = (value) => {
    setSelectUser(value);
    setSelectAll(value.length === userList.length);
  };

  const getList = (type) => {
    setLoading(true);
    request({
      url:
        type === "Customer"
          ? `${api.customerList}`
          : `${api.serviceProviderList}`,
      method: "GET",
      onSuccess: ({ data }) => {
        setUserList(data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const filterUserOption = (input, option) => {
    console.log(input, option, "------ hfdkjgfhdbfjdg");
    const inputValue = input.toLowerCase();

    let optionLabel = "";
    if (option && option.props && option.props.children) {
      if (Array.isArray(option.props.children)) {
        optionLabel = option.props.children.join("").toLowerCase();
      } else if (typeof option.props.children === "string") {
        optionLabel = option.props.children.toLowerCase();
      } else {
        optionLabel = option.props.children.toString().toLowerCase();
      }
    }
    if (!optionLabel) {
      return false;
    }
    const [code, phone] = optionLabel.split("-").map((item) => item || "");

    return (
      optionLabel.includes(inputValue) ||
      (code && code.includes(inputValue)) ||
      (phone && phone.includes(inputValue))
    );
  };

  const onCreate = (values) => {
    const { title, message } = values;
    setLoading(true);
    const payload = {};
    payload.title = title;
    payload.message = message;
    payload.notification_for = selectType ? selectType : "All";
    payload.is_all = selectAll;
    if (selectType != "All") {
      payload.selectUser = selectUser.length > 0 ? selectUser : [];
    }

    request({
      url: api.add,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      open={show}
      width={700}
      title="Send Notification"
      okText="Send"
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Row>
          <Col span={24}>
            <Form.Item
              label="Select User Type"
              name="name"
              rules={[{ required: true, message: "Please Enter the Name!" }]}
            >
              <Select
                placeholder="Select User Type"
                onChange={handleTypeChange}
              >
                <option key="1" value="All">
                  All
                </option>
                <option key="2" value="Customer">
                  Customer
                </option>
                <option key="3" value="ServiceProvider">
                  Service Provider
                </option>
              </Select>
            </Form.Item>
          </Col>

          {/* <Col span={24}> */}
          {selectType != "All" ? (
            <>
              <Col span={24} md={24} className="verticalCustomSelect">
                {userList.length !== 0 && (
                  <>
                    <Checkbox checked={selectAll} onChange={handleSelectAll}>
                      Select All
                    </Checkbox>
                    {showError && (
                      <div style={{ color: "red", marginTop: "8px" }}>
                        Please check this box to proceed.
                      </div>
                    )}
                  </>
                )}
                <button onClick={handleSubmit}>Submit</button>
              </Col>

              <Col span={24} md={24}>
                {!selectAll ? (
                  <Form.Item
                    label={`Select ${selectType}`}
                    name="user"
                    rules={[
                      { required: true, message: "Please select Users!" },
                    ]}
                  >
                    <Select
                      className="selectNotification selectbox-width newSelect multiSelect"
                      showSearch
                      onChange={handleUserChange}
                      filterOption={filterUserOption}
                      placeholder={`Select ${selectType}`}
                      mode="multiple"
                      value={selectUser}
                    >
                      {userList &&
                        userList.length > 0 &&
                        userList.map((item) => (
                          <option key={item._id} value={item._id}>
                            {item.name}{" "}
                            {item?.username ? `(${item.username})` : ""}
                          </option>
                        ))}
                    </Select>
                  </Form.Item>
                ) : null}
              </Col>
            </>
          ) : null}
          {/* </Col> */}

          <Col span={24}>
            <Form.Item
              label="Title"
              name="title"
              rules={[{ required: true, message: "Please enter the title!" }]}
            >
              <Input
                placeholder="Enter The Notification Title"
                maxLength={150}
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label="Message"
              name="message"
              rules={[{ required: true, message: "Please enter the message!" }]}
            >
              <Input.TextArea
                showCount
                maxLength={1000}
                style={{ height: 120, marginBottom: 15 }}
                placeholder="Enter The Notification Message"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default Index;
